var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhotiofinal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122 15.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#828282;}.cls-2{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m3.74,3.8h3.74v3.74h-3.74v-3.74Zm0,7.48H0v3.74h3.74v-3.74Zm0,0h7.48V.06H0v7.48h3.74v3.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m54.82,6.54h-11.11V0h-1.96v15.04h1.96v-6.54h11.11v6.54h1.96V0h-1.96v6.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m100.58,15.04h1.96V0h-1.96v15.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m68.96,13.07c-3.06,0-5.55-2.49-5.55-5.55s2.49-5.55,5.55-5.55,5.55,2.49,5.55,5.55c0,3.06-2.49,5.55-5.55,5.55Zm0-13.07C64.81,0,61.44,3.37,61.44,7.52s3.37,7.52,7.52,7.52,7.52-3.37,7.52-7.52S73.1,0,68.96,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m114.48,13.07c-3.06,0-5.55-2.49-5.55-5.55s2.49-5.55,5.55-5.55,5.55,2.49,5.55,5.55-2.49,5.55-5.55,5.55ZM114.48,0C110.33,0,106.96,3.37,106.96,7.52s3.37,7.52,7.52,7.52,7.52-3.37,7.52-7.52S118.63,0,114.48,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m35.26.77C34.54.27,33.69,0,32.82,0h-10.79v1.96h10.79c1.26,0,2.29,1.03,2.29,2.29s-1.03,2.29-2.29,2.29h-10.79v8.5h1.97v-6.54h8.82c.88,0,1.72-.27,2.44-.77.4-.28.75-.63,1.04-1.04.51-.72.77-1.56.77-2.44s-.27-1.72-.77-2.44c-.28-.4-.63-.75-1.04-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m80.91,1.97h6.54v13.07h1.97V1.97h6.54V0h-15.04v1.97Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotiofinal);
export default __webpack_public_path__ + "static/media/Photiofinal.47d45059732d733e64e20ebd44d6c70a.svg";
export { ForwardRef as ReactComponent };